<template>
    <div class="footer">
        <p>Copyright &copy; <a href="https://nayeemdev.github.io">@nayeemdev</a></p>
        <p>See in Github <a href="https://github.com/nayeemdev/TaskTrackerVue">TaskTrackerVue</a></p>
    </div>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style>
    .footer {
        text-align: center;
        margin-top: 10px;
    }
</style>